// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const successStep = "SuccessStep__successStep__iR8a0";
export const buttonWrapper = "SuccessStep__buttonWrapper__KMBLh";
export const noteTitle = "SuccessStep__noteTitle__VM5dN";
export const noteText = "SuccessStep__noteText__I-lCI";